import { createI18n } from "vue-i18n";
import _ from "lodash";
import { IncidentType } from "@moderrotech/servers-communication-library/src/types";

const messages = {
  en: {
    topics: {
      headerTitle: "Topics",
      title: "Call Online Advisor",
      search: "Search",
      noTopics: "No topics found",
      notFound: "No topics matching pattern found",
      schedule: {
        title: "ONLINE ADVISING sessions are available:",
        closed: "We are closed"
      },
      customerInfoForm: {
        title: "Before we begin your video call...",
        description:
          "Before using video banking to apply your loan, please complete the form",
        labels: {
          name: "Your name",
          surname: "Surname",
          secondSurname: "Last surname",
          id: "ID/ Passport",
          email: "Email address",
          phone: "Phone number"
        },
        optional: "Optional",
        buttons: {
          cancel: "Cancel",
          submit: "Start video call"
        }
      }
    },
    call: {
      calling: "Calling an expert",
      joining: "Joining the call",
      transferring: "Transferring the call",
      aspectRatio: "Zoom",
      cancel: "Cancel call",
      end: "End call",
      share: "Multi party call",
      document: "Document",
      actions: "Actions",
      closeActions: "Cancel",
      mute: "Mute",
      unmute: "Unmute",
      textMessage: "Text Message",
      queuePosition: (ctx: { list: Function }) => {
        const position = ctx.list(0);
        const isPositionAvailable = ctx.list(1);
        return `You are ${isPositionAvailable ? `#${position} ` : ""} in queue`;
      },
      ticket: "Ticket",
      camera: {
        enable: "Enable camera",
        disable: "Disable camera"
      },
      hangupRequest: {
        title: "Are you sure?",
        body: "Do you really want to disconnect?",
        yes: "Yes, hangup",
        no: "No, stay on call"
      },
      downloadFileRequest: {
        title: "Agent has shared a file with you",
        yes: "Download",
        no: "Dismiss"
      },
      openUrlRequest: {
        title: "Open URL",
        body: "The expert wants to open a URL in new tab",
        yes: "Open URL",
        no: "Cancel"
      },
      lowPerformanceNotification: {
        title:
          "Looks your device has low performance. Please, do not use camera to avoid app crashing",
        gotIt: "Got it"
      },
      signaturePad: {
        title: "Sign here",
        description: "Please, draw your signature inside this dotted area.",
        submit: "Submit",
        clear: "Clear",
        cancel: "Cancel"
      },
      textMessageForm: {
        placeholder: "Message"
      },
      success: {
        document: "Document has been successfully sent.",
        feedback: "A feedback has been sent",
        textMessage: "The text message has been sent",
        signaturePad: "The signature has been sent",
        textHintCopy: "The text has been copied to clipboard",
        callSharing: "The link has been copied to clipboard"
      },
      error: {
        base: "Something went wrong. Please, reload the page",
        mediaInputsAccess:
          "Can not get access to microphone and/or camera. Please, enable them in settings",
        join: "Can not join to the call",
        document: "Can not send document",
        noExperts: "No experts available",
        noTopic: "Topic is no longer available",
        timeout: "Waiting for an expert too long",
        documentSize: "The document is too large",
        feedback: "Something went wrong",
        noRoom: "The appointment has expired or was canceled by doctor",
        textMessage: "The text message can not be sent",
        signaturePad: "The signature can not be sent",
        textHintCopy: "Can not copy text",
        callSharing: "Can not share link",
        recordTranslation: {
          play: "Can not play translation audio",
          streamGetting: "Can not get audio stream",
          transcription: "Can not transcribe the record",
          translation: "Can not translate the record",
          unsupportedLanguage:
            "Selected unsupported for YOUR audio translation language. But expert`s audio can be translated on this language"
        }
      },
      onHold: {
        title: "On hold.",
        description: "The agent will get back to you shortly."
      },
      remoteActionRequest: {
        shareFile: {
          title: "The expert wants to share a file from your device. Allow?",
          yes: "Yes",
          no: "No"
        },
        screenSharing: {
          title: "The expert wants to see your screen. Allow?",
          yes: "Yes",
          no: "No"
        }
      },
      settings: {
        title: "Settings",
        labels: {
          camera: "Camera",
          microphone: "Microphone"
        }
      }
    },
    thank: {
      title: (ctx: { list: Function }) => {
        const feedbackEnabled = ctx.list(0);
        return feedbackEnabled
          ? "Please, evaluate your experience of using our service today:"
          : "Thank you for a call";
      },
      toTopics: "Return to topics",
      redirect: "To appointment"
    },
    ticket: {
      creationRequest: {
        title: (ctx: { list: Function }) => {
          const incidentType = ctx.list(0);
          return incidentType === IncidentType.queueTimeout
            ? "Timed out."
            : "No experts available to answer your call.";
        },
        body:
          "You can leave a message for your agents so they can contact you as soon they are available",
        yes: "Create a ticket",
        no: "No, thanks"
      },
      form: {
        labels: {
          phone: "Phone",
          email: "Email",
          message: "Message"
        },
        buttons: {
          cancel: "Cancel",
          submit: "Send a message"
        }
      }
    },
    error: {
      network: {
        title: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "The Agent is staying with you and will talk to you in a moment."
            : "Please be sure you have Internet access";
        },

        description: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "We are about to restore your connection."
            : "Server connection has been lost. Reconnecting...";
        }
      },
      login: {
        credentials: "Wrong username or password",
        default: "Something went wrong"
      }
    }
  },
  ca: {
    topics: {
      headerTitle: "Temes",
      title: "Truqueu a l'assessor en línia",
      search: "Cerca",
      noTopics: "No s'han trobat temes",
      notFound: "No s'ha trobat cap tema que coincideixi amb el patró",
      schedule: {
        title: "L'horari de suport de tramitació online és:",
        closed: "Estem tancats"
      },
      customerInfoForm: {
        title: "Per iniciar una videotrucada, omple el formulari",
        labels: {
          name: "Nom",
          surname: "Cognom",
          id: "DNI/ Passaport",
          email: "Correu electrònic",
          phone: "Número de telèfon"
        },
        optional: "Opcional",
        buttons: {
          cancel: "Cancel·lar",
          submit: "Inicia la videotrucada"
        }
      }
    },
    call: {
      calling: "Trucant a un agent",
      joining: "Adhesió a la convocatòria",
      transferring: "Transferència de la trucada",
      aspectRatio: "Zoom",
      cancel: "Cancel·la la trucada",
      end: "Cancel·lar",
      share: "Trucada multipartícipe",
      document: "Document",
      actions: "Accions",
      closeActions: "Cancel · lar",
      mute: "Silenciar",
      unmute: "Activa el so",
      textMessage: "Missatge de text",
      queuePosition: (ctx: { list: Function }) => {
        const position = ctx.list(0);
        const isPositionAvailable = ctx.list(1);
        return `Ets ${
          isPositionAvailable ? `el número ${position} ` : ""
        } a la cua`;
      },
      ticket: "Bitllet",
      camera: {
        enable: "Activa la càmera",
        disable: "Desactiva la càmera"
      },
      hangupRequest: {
        title: "Estàs segur?",
        body: "Realment vols desconnectar?",
        yes: "Sí, penja",
        no: "No, torna a la trucada"
      },
      downloadFileRequest: {
        title: "L'agent ha compartit un fitxer amb tu",
        yes: "Descarregar",
        no: "Descartar"
      },
      openUrlRequest: {
        title: "Obre l'URL",
        body: "L'expert vol obrir un URL en una pestanya nova",
        yes: "Obre l'URL",
        no: "Cancel · lar"
      },
      lowPerformanceNotification: {
        title:
          "Sembla que el teu dispositiu té un rendiment baix. Si us plau, no utilitzeu la càmera per evitar que l'aplicació es bloquegi",
        gotIt: "Ho tinc"
      },
      signaturePad: {
        title: "Signa aquí",
        description:
          "Si us plau, dibuixeu la vostra signatura dins d'aquesta àrea de punts.",
        submit: "Presentar",
        clear: "Netejar",
        cancel: "Cancel · lar"
      },
      textMessageForm: {
        placeholder: "Missatge"
      },
      success: {
        document: "El document s'ha enviat correctament",
        feedback: "S'ha enviat un comentari",
        textMessage: "Missatge de text",
        signaturePad: "S'ha enviat la signatura",
        textHintCopy: "El text s'ha copiat al porta-retalls",
        callSharing: "L'enllaç s'ha copiat al porta-retalls"
      },
      error: {
        base:
          "Alguna cosa ha anat malament. Si us plau, torneu a carregar la pàgina",
        mediaInputsAccess:
          "No es pot accedir al micròfon i/o la càmera. Si us plau, activeu-los a la configuració",
        join: "No es pot unir a la trucada",
        document: "No es pot enviar el document",
        noExperts: "No hi ha experts disponibles",
        noTopic: "El tema ja no està disponible",
        timeout: "Esperar un expert massa temps",
        documentSize: "El document és massa gran",
        feedback: "Alguna cosa ha anat malament",
        noRoom: "La cita ha caducat o ha estat cancel·lada",
        textMessage: "El missatge de text no es pot enviar",
        signaturePad: "La signatura no es pot enviar",
        textHintCopy: "No es pot copiar el text",
        callSharing: "No es pot compartir l'enllaç",
        recordTranslation: {
          play: "No es pot reproduir l'àudio de la traducció",
          streamGetting: "No es pot obtenir la reproducció d'àudio",
          transcription: "No es pot transcriure el registre",
          translation: "No es pot traduir el registre",
          unsupportedLanguage:
            "S'ha seleccionat que no s'admet per al TEU idioma de traducció d'àudio. Però l'àudio de l'expert es pot traduir en aquest idioma"
        }
      },
      onHold: {
        title: "En espera.",
        description: "L'agent us respondrà en breu."
      },
      remoteActionRequest: {
        shareFile: {
          title:
            "L'expert vol compartir un fitxer des del vostre dispositiu. Permetre?",
          yes: "Sí",
          no: "No"
        },
        screenSharing: {
          title: "L'expert vol veure la teva pantalla. Permetre?",
          yes: "Sí",
          no: "No"
        }
      },
      settings: {
        title: "Configuració",
        labels: {
          camera: "Càmera",
          microphone: "Micròfon"
        }
      }
    },
    thank: {
      title: (ctx: { list: Function }) => {
        const feedbackEnabled = ctx.list(0);
        return feedbackEnabled
          ? "Si us plau, avalueu la vostra experiència amb el nostre servei avui:"
          : "Gràcies per la trucada";
      },
      toTopics: "Tornar als temes",
      redirect: "A cita"
    },
    ticket: {
      creationRequest: {
        title: (ctx: { list: Function }) => {
          const incidentType = ctx.list(0);
          return incidentType === IncidentType.queueTimeout
            ? "S'ha acabat el temps."
            : "No hi ha experts disponibles per respondre la vostra trucada.";
        },
        body:
          "Podeu deixar un missatge als vostres agents perquè es posin en contacte amb vosaltres tan aviat com estiguin disponibles",
        yes: "Crea un bitllet",
        no: "No gràcies"
      },
      form: {
        labels: {
          phone: "Telèfon",
          email: "Correu electrònic",
          message: "Missatge"
        },
        buttons: {
          cancel: "Cancel · lar",
          submit: "Enviar un missatge"
        }
      }
    },
    error: {
      network: {
        title: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "L'agent es queda amb tu i et parlarà en un moment."
            : "Avís!";
        },
        description: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "Estem a punt de restablir la teva connexió."
            : "S'ha perdut la connexió del servidor. S'està tornant a connectar...";
        }
      },
      login: {
        credentials: "Nom d'usuari o contrasenya incorrectes",
        default: "Alguna cosa ha anat malament"
      }
    }
  },
  es: {
    topics: {
      headerTitle: "Temas",
      title: "Llame al asesor en línea",
      search: "Búsqueda",
      noTopics: "No se encontraron temas",
      notFound: "No se encontraron temas que coincidan con el patrón",
      schedule: {
        title: "Las sesiones de ASESORÍA ONLINE están disponibles:",
        closed: "Estamos cerrados"
      },
      customerInfoForm: {
        title: "Antes de comenzar su videollamada...",
        description:
          "Antes de utilizar la video banca para solicitar su préstamo, por favor, complete el formulario",
        labels: {
          name: "Su nombre",
          surname: "Apellido",
          id: "DNI/ Pasaporte",
          email: "Dirección de correo electrónico",
          phone: "Número de teléfono"
        },
        optional: "Opcional",
        buttons: {
          cancel: "Cancelar",
          submit: "Iniciar videollamada"
        },
        agreement:
          'Al hacer clic en "Iniciar videollamada", aceptas nuestros Términos de servicio.'
      }
    },
    call: {
      calling: "Llamando a un experto",
      joining: "Unirse a la llamada",
      transferring: "Transferir la llamada",
      aspectRatio: "Zoom",
      cancel: "Cancelar llamada",
      end: "Finalizar llamada",
      share: "Llamada multipartita",
      document: "Documento",
      actions: "Comportamiento",
      closeActions: "Cancelar",
      mute: "Mudo",
      unmute: "No silenciar",
      textMessage: "Mensaje de texto",
      queuePosition: (ctx: { list: Function }) => {
        const position = ctx.list(0);
        const isPositionAvailable = ctx.list(1);
        return `Eres el ${
          isPositionAvailable ? `#${position} ` : ""
        }en la cola`;
      },
      ticket: "Boleto",
      camera: {
        enable: "Habilitar cámara",
        disable: "Deshabilitar cámara"
      },
      hangupRequest: {
        title: "Estas seguro",
        body: "¿De verdad quieres desconectar?",
        yes: "si, colgar",
        no: "No, quédate en la llamada"
      },
      downloadFileRequest: {
        title: "El agente ha compartido un archivo con usted.",
        yes: "Descargar",
        no: "Descartar"
      },
      openUrlRequest: {
        title: "Abrir URL",
        body: "El experto quiere abrir una URL en una nueva pestaña",
        yes: "Abrir URL",
        no: "Cancelar"
      },
      lowPerformanceNotification: {
        title:
          "Parece que el dispositivo tiene un rendimiento bajo. Por favor, no utilice la cámara para evitar que la aplicación se bloquee",
        gotIt: "Entiendo"
      },
      signaturePad: {
        title: "Firma aqui",
        description: "Por favor, dibuje su firma dentro de esta área punteada.",
        submit: "Entregar",
        clear: "Limpiar",
        cancel: "Cancelar"
      },
      textMessageForm: {
        placeholder: "Mensaje"
      },
      success: {
        document: "El documento ha sido enviado con éxito.",
        feedback: "Se ha enviado un comentario.",
        textMessage: "El mensaje de texto ha sido enviado",
        signaturePad: "La firma ha sido enviada.",
        textHintCopy: "El texto ha sido copiado al portapapeles.",
        callSharing: "El enlace ha sido copiado al portapapeles."
      },
      error: {
        base: "Algo salió mal. Por favor recarga la página",
        mediaInputsAccess:
          "No puedo acceder al micrófono y/o a la cámara. Por favor, habilítelos en la configuración.",
        join: "No puedo unirme a la llamada",
        document: "No se puede enviar el documento",
        noExperts: "No hay expertos disponibles",
        noTopic: "El tema ya no está disponible",
        timeout: "Esperando a un experto demasiado tiempo",
        documentSize: "El documento es demasiado grande.",
        feedback: "Algo salió mal",
        noRoom: "La cita ha expirado o fue cancelada",
        textMessage: "El mensaje de texto no se puede enviar",
        signaturePad: "No se puede enviar la firma.",
        textHintCopy: "No se puede copiar texto",
        callSharing: "No se puede compartir enlace",
        recordTranslation: {
          play: "No se puede reproducir el audio de traducción",
          streamGetting: "No se puede obtener la transmisión de audio",
          transcription: "No se puede transcribir el registro",
          translation: "No se puede traducir el registro",
          unsupportedLanguage:
            "Seleccionado no compatible con SU idioma de traducción de audio. Pero el audio del experto se puede traducir a este idioma."
        }
      },
      onHold: {
        title: "En espera.",
        description: "El agente se pondrá en contacto con usted en breve."
      },
      remoteActionRequest: {
        shareFile: {
          title:
            "El experto quiere compartir un archivo desde su dispositivo. ¿Permitir?",
          yes: "Sí",
          no: "No"
        },
        screenSharing: {
          title: "El experto quiere ver tu pantalla. ¿Permitir?",
          yes: "Sí",
          no: "No"
        }
      },
      settings: {
        title: "Ajustes",
        labels: {
          camera: "Cámara",
          microphone: "Micrófono"
        }
      }
    },
    thank: {
      title: (ctx: { list: Function }) => {
        const feedbackEnabled = ctx.list(0);
        return feedbackEnabled
          ? "Por favor, evalúe su experiencia usando nuestro servicio hoy:"
          : "Gracias por la llamada";
      },
      toTopics: "Regresar a la página principal",
      redirect: "A la cita"
    },
    ticket: {
      creationRequest: {
        title: (ctx: { list: Function }) => {
          const incidentType = ctx.list(0);
          return incidentType === IncidentType.queueTimeout
            ? "Caducado."
            : "No hay expertos disponibles para responder a su llamada.";
        },
        body:
          "Puede dejar un mensaje a sus agentes para que se comuniquen con usted tan pronto como estén disponibles.",
        yes: "Crear un billete",
        no: "No, gracias"
      },
      form: {
        labels: {
          phone: "Teléfono",
          email: "Correo electrónico",
          message: "Mensaje"
        },
        buttons: {
          cancel: "Cancelar",
          submit: "Enviar un mensaje"
        }
      }
    },
    error: {
      network: {
        title: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "El Agente hablará contigo en un momento."
            : "¡Advertencia!";
        },
        description: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "Estamos a punto de restaurar su conexión."
            : "Se ha perdido la conexión con el servidor. Reconectando...";
        }
      },
      login: {
        credentials: "Nombre de usuario o contraseña incorrectos",
        default: "Algo salió mal"
      }
    }
  },
  he: {
    topics: {
      headerTitle: "נושאי פנייה",
      title: "לשיחת וידאו עם נציג",
      search: "חיפוש",
      noTopics: "לא נמצאו נושאים",
      notFound: "לא נמצאו נושאים התואמים את החיפוש",
      schedule: {
        title: "נציגים זמינים לתמיכה בוידאו",
        closed: "השירות לא זמין כעת"
      },
      customerInfoForm: {
        title: "לפני שנתחיל בשיחת הווידאו שלך...",
        description:
          "לפני השימוש בבנקאות וידאו ליישום ההלוואה שלך, אנא מלא את הטופס",
        labels: {
          name: "השם שלך",
          surname: "שֵׁם מִשׁפָּחָה",
          id: "תעודה מזהה/דרכון",
          email: 'כתובת דוא"ל',
          phone: "מספר טלפון"
        },
        optional: "אופציונאלי",
        buttons: {
          cancel: "לְבַטֵל",
          submit: "התחל שיחת וידאו"
        }
      }
    },
    call: {
      calling: "מתקשר לנציג",
      joining: "מצטרף לשיחה",
      transferring: "השיחה מועברת",
      aspectRatio: "תקריב",
      cancel: "ביטול שיחה",
      end: "ניתוק שיחה",
      share: "שיחה רב צדדית",
      document: "קובץ",
      actions: "פעולות",
      closeActions: "ביטול",
      mute: "השתקה",
      unmute: "ביטול השתקה",
      textMessage: "הודעת טקסט",
      queuePosition: (ctx: { list: Function }) => {
        const position = ctx.list(0);
        const isPositionAvailable = ctx.list(1);
        return isPositionAvailable
          ? _.reverse(["בתור", position, "מיקומך"]).join(" ")
          : "מיקומך בתור";
      },
      ticket: "פנייה",
      camera: {
        enable: "הפעלת מצלמה",
        disable: "הפסקת מצלמה"
      },
      hangupRequest: {
        title: "?בטוח",
        body: "?לנתק את השיחה",
        yes: "כן, לנתק",
        no: "לא, להישאר בשיחה"
      },
      downloadFileRequest: {
        title: "נציג שיתף איתך קובץ",
        yes: "להורדת הקובץ",
        no: "לביטול"
      },
      openUrlRequest: {
        title: "פתיחת קישור",
        body: "הנציג רוצה לפתוח את הקישור בלשונית נפרדת",
        yes: "לפתוח קישור",
        no: "לביטול"
      },
      lowPerformanceNotification: {
        title:
          "נראה שהמכשיר שלך איטי, יש לסגור את המצלמה כדי להמנע מאיטיות בשיחה",
        gotIt: "הבנתי"
      },
      signaturePad: {
        title: "לחתימה",
        description: "יש לחתום בתוך המקום המסומן",
        submit: "שליחה",
        clear: "מחיקה",
        cancel: "ביטול"
      },
      textMessageForm: {
        placeholder: "הוֹדָעָה"
      },
      success: {
        document: "הקובץ נשלח בהצלחה",
        feedback: "הפידבק נשלח",
        textMessage: "הודעת הטקסט נשלחה",
        signaturePad: "החתימה נשלחה",
        textHintCopy: "הטקסט הועתק",
        callSharing: "הקישור הועתק ללוח"
      },
      error: {
        base: "משהו השתבש. טען מחדש את העמוד בבקשה",
        mediaInputsAccess:
          "לא ניתן לקבל גישה למיקרופון ו/או למצלמה. אנא הפעל אותם בהגדרות",
        join: "לא ניתן להצטרף לשיחה",
        document: "לא ניתן לשלוח את הקובץ",
        noExperts: "אין נציגים זמינים",
        noTopic: "נושא הפנייה כבר לא זמין",
        timeout: "לנציג לוקח יותר מדי זמן לעלות לשיחה",
        documentSize: "הקובץ גדול מדי",
        feedback: "משהו השתבש",
        noRoom: "מועד הפגישה פג או בוטל",
        textMessage: "לא ניתן לשלוח את הודעת הטקסט",
        signaturePad: "לא ניתן לשלוח את החתימה",
        textHintCopy: "לא ניתן להעתיק את הטקסט",
        callSharing: "לא ניתן לשתף קישור",
        recordTranslation: {
          play: "לא ניתן להשמיע אודיו לתרגום",
          streamGetting: "לא ניתן להשיג זרם אודיו",
          transcription: "לא ניתן לתמלל את הרשומה",
          translation: "לא ניתן לתרגם את הרשומה",
          unsupportedLanguage:
            "נבחרה לא נתמכת עבור שפת תרגום האודיו שלך. אבל ניתן לתרגם את האודיו של המומחה בשפה זו"
        }
      },
      onHold: {
        title: "בהמתנה",
        description: "הנציג כבר יהיה איתך"
      },
      remoteActionRequest: {
        shareFile: {
          title: ["הנציג רוצה לשתף קובץ מהמכשיר שלך. להסכים", "?"].join(""),
          yes: "כן",
          no: "לא"
        },
        screenSharing: {
          title: ["המומחה רוצה לראות את המסך שלך. להתיר", "?"].join(""),
          yes: "כן",
          no: "לא"
        }
      },
      settings: {
        title: "הגדרות",
        labels: {
          camera: "מצלמה",
          microphone: "מיקרופון"
        }
      }
    },
    thank: {
      title: (ctx: { list: Function }) => {
        const feedbackEnabled = ctx.list(0);
        return feedbackEnabled
          ? "נשמח לדעת מה חשבת על השירות שקיבלת היום"
          : "תודה רבה שיצרת איתנו קשר";
      },
      toTopics: "בחזרה לנושאים",
      redirect: "למועד שנקבע מראש"
    },
    ticket: {
      creationRequest: {
        title: (ctx: { list: Function }) => {
          const incidentType = ctx.list(0);
          return incidentType === IncidentType.queueTimeout
            ? "נגמר הזמן."
            : "אין מומחים זמינים לענות לשיחתך.";
        },
        body:
          "אתה יכול להשאיר הודעה לסוכנים שלך כדי שיוכלו ליצור איתך קשר ברגע שהם יהיו זמינים",
        yes: "צור כרטיס",
        no: "לא תודה"
      },
      form: {
        labels: {
          phone: "טלפון",
          email: "אימייל",
          message: "הוֹדָעָה"
        },
        buttons: {
          cancel: "לְבַטֵל",
          submit: "שלח הודעה"
        }
      }
    },
    error: {
      network: {
        title: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "הנציג עדיין איתך וכבר ישוב לשיחה"
            : "בבקשה לוודא שיש גישה לאינטרנט";
        },
        description: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "כבר מחברים אותך בחזרה"
            : "החיבור לשרת נותק. מחברים אותך מחדש";
        }
      },
      login: {
        credentials: "שם משתמש או סיסמה שגויים",
        default: "משהו לא עובד לנו"
      }
    }
  },
  pt: {
    topics: {
      headerTitle: "Tópicos",
      title: "Ligue para o consultor on-line",
      search: "Procurar",
      noTopics: "Nenhum tópico encontrado",
      notFound: "Nenhum tópico correspondente ao padrão encontrado",
      schedule: {
        title: "Estão disponíveis sessões de ACONSELHAMENTO ONLINE:",
        closed: "Estamos fechados"
      },
      customerInfoForm: {
        title: "Antes de começarmos sua videochamada...",
        description:
          "Antes de usar o videobanking para solicitar seu empréstimo, preencha o formulário",
        labels: {
          name: "Seu nome",
          surname: "Sobrenome",
          secondSurname: "Último sobrenome",
          id: "ID/ Passaporte",
          email: "Endereço de email",
          phone: "Número de telefone"
        },
        optional: "Opcional",
        buttons: {
          cancel: "Cancelar",
          submit: "Iniciar videochamada"
        }
      }
    },
    call: {
      calling: "Chamando um especialista",
      joining: "Entrando na chamada",
      transferring: "Transferindo a chamada",
      aspectRatio: "Ampliação",
      cancel: "Cancelar chamada",
      end: "Encerrar chamada",
      share: "Chamada multipartidária",
      document: "Documento",
      actions: "Ações",
      closeActions: "Cancelar",
      mute: "Mudo",
      unmute: "Ativar som",
      textMessage: "Mensagem de texto",
      queuePosition: (ctx: { list: Function }) => {
        const position = ctx.list(0);
        const isPositionAvailable = ctx.list(1);
        return isPositionAvailable
          ? `Você é o número ${position} na fila`
          : "Você está na fila";
      },
      ticket: "Bilhete",
      camera: {
        enable: "Ativar câmera",
        disable: "Desativar câmera"
      },
      hangupRequest: {
        title: "Tem certeza?",
        body: "Você realmente quer se desconectar?",
        yes: "Sim, desligar",
        no: "Não, fique de plantão"
      },
      downloadFileRequest: {
        title: "O agente compartilhou um arquivo com você",
        yes: "Download",
        no: "Liberar"
      },
      openUrlRequest: {
        title: "Abrir URL",
        body: "O especialista deseja abrir um URL em uma nova guia",
        yes: "Abrir URL",
        no: "Cancelar"
      },
      lowPerformanceNotification: {
        title:
          "Parece que seu dispositivo tem baixo desempenho. Por favor, não use a câmera para evitar travamento do aplicativo",
        gotIt: "Entendi"
      },
      signaturePad: {
        title: "Assine aqui",
        description:
          "Por favor, desenhe sua assinatura dentro desta área pontilhada.",
        submit: "Enviar",
        clear: "Claro",
        cancel: "Cancelar"
      },
      textMessageForm: {
        placeholder: "Mensagem"
      },
      success: {
        document: "O documento foi enviado com sucesso.",
        feedback: "Um feedback foi enviado",
        textMessage: "A mensagem de texto foi enviada",
        signaturePad: "A assinatura foi enviada",
        textHintCopy: "O texto foi copiado para a área de transferência",
        callSharing: "O link foi copiado para a área de transferência"
      },
      error: {
        base: "Algo deu errado. Por favor recarregue a página",
        mediaInputsAccess:
          "Não é possível obter acesso ao microfone e/ou câmera. Por favor, ative-os nas configurações",
        join: "Não é possível participar da chamada",
        document: "Não é possível enviar documento",
        noExperts: "Nenhum especialista disponível",
        noTopic: "O tópico não está mais disponível",
        timeout: "Esperando muito por um especialista",
        documentSize: "O documento é muito grande",
        feedback: "Algo deu errado",
        noRoom: "A consulta expirou ou foi cancelada pelo médico",
        textMessage: "A mensagem de texto não pode ser enviada",
        signaturePad: "A assinatura não pode ser enviada",
        textHintCopy: "Não é possível copiar texto",
        callSharing: "Não é possível compartilhar o link",
        recordTranslation: {
          play: "Não é possível reproduzir o áudio da tradução",
          streamGetting: "Não é possível obter fluxo de áudio",
          transcription: "Não é possível transcrever o registro",
          translation: "Não é possível traduzir o registro",
          unsupportedLanguage:
            "Selecionado como não suportado para SEU idioma de tradução de áudio. Mas o áudio do especialista pode ser traduzido neste idioma"
        }
      },
      onHold: {
        title: "Em espera.",
        description: "O agente entrará em contato com você em breve."
      },
      remoteActionRequest: {
        shareFile: {
          title:
            "O especialista deseja compartilhar um arquivo do seu dispositivo. Permitir?",
          yes: "Sim",
          no: "Não"
        },
        screenSharing: {
          title: "O especialista quer ver sua tela. Permitir?",
          yes: "Sim",
          no: "Não"
        }
      },
      settings: {
        title: "Configurações",
        labels: {
          camera: "Câmera",
          microphone: "Microfone"
        }
      }
    },
    thank: {
      title: (ctx: { list: Function }) => {
        const feedbackEnabled = ctx.list(0);
        return feedbackEnabled
          ? "Por favor, avalie sua experiência de uso de nosso serviço hoje:"
          : "Obrigado por uma ligação";
      },
      toTopics: "Voltar aos tópicos",
      redirect: "Para consulta"
    },
    ticket: {
      creationRequest: {
        title: (ctx: { list: Function }) => {
          const incidentType = ctx.list(0);
          return incidentType === IncidentType.queueTimeout
            ? "Tempo esgotado."
            : "Nenhum especialista disponível para atender sua chamada.";
        },
        body:
          "Você pode deixar uma mensagem para seus agentes para que eles possam entrar em contato com você assim que estiverem disponíveis",
        yes: "Crie um tíquete",
        no: "Não, obrigado"
      },
      form: {
        labels: {
          phone: "Telefone",
          email: "E-mail",
          message: "Mensagem"
        },
        buttons: {
          cancel: "Cancelar",
          submit: "Envie uma mensagem"
        }
      }
    },
    error: {
      network: {
        title: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "O Agente está hospedado com você e falará com você em um momento."
            : "Certifique-se de ter acesso à Internet";
        },

        description: (ctx: { list: Function }) => {
          const isOnCall = ctx.list(0);
          return isOnCall
            ? "Estamos prestes a restaurar sua conexão."
            : "A conexão do servidor foi perdida. Reconectando...";
        }
      },
      login: {
        credentials: "Nome de usuário ou senha errados",
        default: "Algo deu errado"
      }
    }
  }
};

export const i18n = createI18n({
  locale: "en",
  fallbackLocale: "en",
  messages
});
